/**
 * Maps Firebase Auth error codes to short Spanish UX copy.
 */
const MESSAGES: Record<string, string> = {
  "auth/wrong-password":
    "La contraseña no es correcta. Verificá e intentá de nuevo o usá «Recuperar contraseña» desde el mismo inicio.",
  "auth/invalid-login-credentials":
    "Correo o contraseña incorrectos. Revisá los datos o pedí recuperar la contraseña.",
  "auth/invalid-credential":
    "Correo o contraseña incorrectos. Revisá los datos o pedí recuperar la contraseña.",
  "auth/user-not-found": "No hay una cuenta registrada con este correo.",
  "auth/invalid-email": "El correo electrónico no tiene un formato válido.",
  "auth/user-disabled": "Esta cuenta fue deshabilitada. Contactá al administrador.",
  "auth/too-many-requests":
    "Demasiados intentos. Esperá unos minutos antes de volver a intentarlo.",
  "auth/network-request-failed":
    "No hay conexión o el servidor no respondió. Revisá tu red e intentá otra vez.",
  "auth/operation-not-allowed":
    "Este método de ingreso no está habilitado. Contactá al administrador.",
  "auth/requires-recent-login":
    "Por seguridad tenés que volver a iniciar sesión para completar esta acción.",
};

export function friendlyFirebaseAuthMessage(err: unknown): string {
  const code = typeof err === "object" && err !== null && "code" in err
    ? String((err as { code?: unknown }).code ?? "").trim()
    : "";
  if (code && MESSAGES[code]) {
    return MESSAGES[code];
  }
  const raw =
    typeof err === "object" && err !== null && "message" in err
      ? String((err as { message?: unknown }).message ?? "")
      : String(err ?? "");
  if (/wrong-password/i.test(raw) || raw.includes("auth/wrong-password")) {
    return MESSAGES["auth/wrong-password"];
  }
  if (/invalid-credential/i.test(raw)) {
    return MESSAGES["auth/invalid-credential"];
  }
  return "No se pudo iniciar sesión. Revisá tus datos y la conexión, o intentá más tarde.";
}
